
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/point_terms",
      function () {
        return require("private-next-pages/point_terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/point_terms"])
      });
    }
  